<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 24 24">
        <!--Generated by IJSVG (https://github.com/iconjar/IJSVG)-->
        <path 
            d="M6,3.25c-1.51878,0 -2.75,1.23122 -2.75,2.75v12c0,1.5188 1.23122,2.75 2.75,2.75h12c1.5188,0 2.75,-1.2312 2.75,-2.75v-12c0,-1.51878 -1.2312,-2.75 -2.75,-2.75h-12Z"
            fill="#536cbc" />
        </svg>
</template>